import { faCancel, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Can } from '../Can';
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { AssignmentToolbarNavigation } from './AssignmentToolbar';

export default class AddDailyTimesheetButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false, forDate: null };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    onAddDailyTimesheet = () => {
        const { onNavigate } = this.props;
        const { forDate } = this.state;

        if (!forDate) {
            return;
        }

        onNavigate(AssignmentToolbarNavigation.ADD, forDate);
    };

    render() {
        const { showModal, forDate } = this.state;

        return (
            <Can I="view" a="dailytimesheet">
                <Button
                    type="button"
                    color="success"
                    onClick={this.toggleModal}
                    className="mr-5"
                >
                    <FontAwesomeIcon icon={faPlusCircle} className="mr-1" />
                    Add a timesheet
                </Button>

                <Modal isOpen={showModal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Add Timesheet
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            If you have been assigned work or want to request
                            time off, please use those forms. This will let you
                            track time worked on jobs.
                        </div>

                        <Input
                            type="date"
                            value={forDate}
                            onChange={(e) =>
                                this.setState({ forDate: e.target.value })
                            }
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            type="button"
                            color="warning"
                            className="mr-auto"
                            onClick={this.toggleModal}
                        >
                            <FontAwesomeIcon icon={faCancel} className="mr-1" />
                            Cancel
                        </Button>

                        <Button
                            type="button"
                            color="success"
                            disabled={!forDate}
                            outline={!forDate}
                            onClick={this.onAddDailyTimesheet}
                        >
                            <FontAwesomeIcon
                                icon={faPlusCircle}
                                className="mr-1"
                            />
                            Add a timesheet
                        </Button>
                    </ModalFooter>
                </Modal>
            </Can>
        );
    }
}
